import { fetchEndpointData } from '@utils/fetchEndpointData';

import type { ClaimResponse, ClaimStatusType } from './endpoints/ClaimEndpoint.types';
import type { CreateClaimBody } from './endpoints/CreateClaimEndpoint.types';
import type { UpdateClaimBody } from './endpoints/UpdateClaimEndpoint.types';

export type { ClaimResponse, ClaimStatusType };

export async function fetchClaims(opts?: {
  search?: string;
  status?: ClaimStatusType;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: string;
}): Promise<ClaimResponse[]> {
  const params = new URLSearchParams();
  if (opts?.search) params.set('search', opts.search);
  if (opts?.status) params.set('status', opts.status);
  if (opts?.limit) params.set('limit', opts.limit.toString());
  if (opts?.offset) params.set('offset', opts.offset.toString());
  if (opts?.sortBy) params.set('sortBy', opts.sortBy);
  if (opts?.sortOrder) params.set('sortOrder', opts.sortOrder);

  const queryString = params.toString();
  const url = queryString ? `/api/v1/claims?${queryString}` : '/api/v1/claims';
  return fetchEndpointData<ClaimResponse[]>(url);
}

export async function fetchClaim(id: string): Promise<ClaimResponse> {
  return fetchEndpointData<ClaimResponse>(`/api/v1/claims/${id}`);
}

export async function createClaim(body: CreateClaimBody): Promise<ClaimResponse> {
  return fetchEndpointData<ClaimResponse>('/api/v1/claims', {
    method: 'POST',
    body,
  });
}

export async function updateClaim(id: string, body: UpdateClaimBody): Promise<ClaimResponse> {
  return fetchEndpointData<ClaimResponse>(`/api/v1/claims/${id}`, {
    method: 'PATCH',
    body,
  });
}

export async function deleteClaim(id: string): Promise<{ success: boolean }> {
  return fetchEndpointData<{ success: boolean }>(`/api/v1/claims/${id}`, {
    method: 'DELETE',
  });
}
